import { CONSTANTS } from "../constants/app-constant";

const {
  FB: { CONNECTED, REAUTH },
} = CONSTANTS;

const loginOpts = {
  scope: "email, pages_show_list, pages_read_engagement, instagram_basic",
  enable_profile_selector: true,
  return_scopes: true,
};

export const fbInit = () => {
  window.fbAsyncInit = function () {
    window.FB.init({
      appId: process.env.REACT_APP_FB_APP_ID,
      autoLogAppEvents: true,
      xfbml: true,
      version: "v7.0",
    });
  };
};

const fbLogin = (type = "") => {
  return new Promise((resolve, reject) => {
    const opts = type ? { ...loginOpts, auth_type: type } : loginOpts;
    window.FB.login(function ({ authResponse, status }) {
      if (authResponse && status === CONNECTED) {
        resolve(authResponse.accessToken);
      } else {
        console.log("User cancelled login or did not fully authorize.");
        reject(null);
      }
    }, opts);
  });
};

export const loginUsingFB = () => {
  return getLoginStatus().then((res) => {
    if (res) {
      return fbLogin(REAUTH);
    } else {
      return fbLogin();
    }
  });
};

export const FBLogout = () => {
  window.FB.getLoginStatus(function (response) {
    if (response && response.status === CONNECTED) {
      window.FB.logout(function () { });
    }
  });
};

const getLoginStatus = () => {
  return new Promise((resolve) => {
    window.FB.getLoginStatus(({ status }) => {
      resolve(status === CONNECTED);
    });
  });
};
